import { get } from "lodash";
import { Store } from "@reduxjs/toolkit";
import { parseJSONCapiMessage } from "@fdr/utils/parseJSONCapiMessage";

export const getVideoCarouselSelector = (store: Store) =>
  get(store, "RaceProgram.videoCarousel", {});

export const getProgramPageVideoPlaylistSettings = (store: Store) =>
  parseJSONCapiMessage(store, "capi.messages.programPagePlaylistSettings", {
    licenseKey: "",
    playerScript: "",
    playlistUrl: ""
  });
